import React from 'react';
import { defaultComponents } from '../../../../../../components/Markdown/components/ReactMarkdown';
import { Markdown } from '../../../../../../components/Markdown';
import { Flex, FlexProps } from '../../../../../../wag-react/next-components/Flex';
import { Box } from '../../../../../../wag-react/next-components/box';
import { theme } from '../../../../../../wag-react/themes/base-theme';
import { Span } from '../../../../../../wag-react/core-components/span';
import { Typography } from '../../../../../../wag-react/components/Typography';
export type TrainingMethodStepProps = {
  description: string;
  name: string;
  num: number;
} & FlexProps;
export const TrainingMethodStep = ({
  description,
  name,
  num,
  ...rest
}: TrainingMethodStepProps) => <Flex {...rest} data-sentry-element="Flex" data-sentry-component="TrainingMethodStep" data-sentry-source-file="index.tsx">
    <Box data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <Box bg={theme.colors.tuftsBlue} borderRadius="16px" px="8px" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Span color="white" fontFamily="muliBold" fontSize="24px" data-sentry-element="Span" data-sentry-source-file="index.tsx">
          {num}
        </Span>
      </Box>
    </Box>
    <Box pl="16px" data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <Box as="h4" color={theme.colors.dimGray} fontFamily="muliBold" fontSize={['mobile-h4', 'tablet-h4', 'desktop-h4']} m={0} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        {name}
      </Box>
      <Markdown components={{
      ...defaultComponents,
      p: props => <Typography m={0} mt="8px" {...props} />
    }} version="react-markdown" data-sentry-element="Markdown" data-sentry-source-file="index.tsx">
        {description}
      </Markdown>
    </Box>
  </Flex>;